import React from 'react';
import { useTranslation } from 'react-i18next';

import { getMonthFullName, sumExpense } from 'src/utils/Dashboard';

import { numberFormat } from './ChartTable';

const ExpenseSummaryChartTooltips = ({ active, payload, label }) => {
  const { t } = useTranslation();
  if (active && payload && sumExpense(payload)) {
    return (
      <div style={{ backgroundColor: '#666', color: 'white', padding: 10, fontSize: '16px' }}>
        <h4>{getMonthFullName(label)}</h4>
        <h4>{`${t('features.Dashbord.components.ExpenseSummaryChartTooltips.total')}: ${numberFormat(sumExpense(payload), 2)}`}</h4>
        {payload &&
          payload.map(
            e =>
              e.value > 0 && (
                <p key={e.dataKey} style={{ color: e.color, fontSize: '14px' }}>
                  {`${e.dataKey}: ${numberFormat(e.value, 2)}`}
                </p>
              )
          )}
      </div>
    );
  }
  return null;
};

export default ExpenseSummaryChartTooltips;
